import gql from 'graphql-tag'

export const NAME = 'resetRegistration'
const RESET_REGISTRATION = gql`
  mutation ${NAME}($id: ID!, $createNew: Boolean) {
    ${NAME}(id: $id, createNew: $createNew)
  }
`
export default RESET_REGISTRATION
